<template>
  <div class="table-wrap">
    <el-table :data="tableData" style="width: 100%" @selection-change="selectionChange" ref="table">
      <!-- <el-table-column
        v-if="type == 'selection'"
        type="selection"
        width="55">
      </el-table-column> -->
      <template v-for="item in tableTitle">
        <!-- 全选 -->
        <el-table-column v-if="item.type == 'selection'" type="selection" width="55">
       </el-table-column>
        <!-- 图片 -->
        <el-table-column v-if="item.type == 'img'" :label="item.label" :prop="item.prop" min-width="120%">
          <template slot-scope="scope">
            <img :width="item.width" :height="item.height" :src='scope.row[item.prop]'/>
          </template>
        </el-table-column>
        <!-- 复选 -->
        <el-table-column v-else-if="item.type == 'checkbox'" :label="item.label" :prop="item.prop" min-width="120%">
          <template slot-scope="scope">
            <el-checkbox v-model="scope.row[item.prop]" @change="goEmit(item.eventName, scope.row)" :disabled="item.disabled" :true-label="item.trueLabel" :false-label="item.falseLabel"></el-checkbox>
          </template>
        </el-table-column>
        <!-- 数据+按钮 -->
          <el-table-column v-else-if="item.type == 'event'" :prop="item.prop" :label="item.label" :key="item.label" min-width="120%" :formatter="item.format">
            <template slot-scope="scope">
              <span>{{scope.row[item.prop]}}</span>
              <span class="btn" @click="goEmit(item.eventName, scope.row)">查看</span>
            </template>
          </el-table-column>
        <!-- 数据复杂格式化 -->
        <el-table-column v-else-if="item.dynamic == true" :prop="item.prop" :label="item.label" :key="item.label" min-width="120%">
          <template slot-scope="scope">
            <span>{{item.format(scope.row[item.prop])}}</span>
          </template>
        </el-table-column>
        <!-- 数据 -->
        <el-table-column v-else :prop="item.prop" :fit="true" :label="item.label" :key="item.label" :min-width="item.coWidth||'120%'" :formatter="item.format"></el-table-column>
      </template>
      <el-table-column v-if="operate" :fixed="fixed" label="操作" :min-width="opwidth">
        <template slot-scope="scope">
          <slot :scope="scope"></slot>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
// import { mapMutations, mapGetters } from 'vuex'

export default {
  data() {
    return {
    }
  },
  props: {
    // 表格title
    tableTitle: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 表格内容
    tableData: {
      type: Array,
      default: () => {
        return []
      }
    },
    opwidth:{
      type:String,
      default:'120%',
    },
    
    // 操作栏是否显示
    operate: {
      type: Boolean,
      default: true
    },
    // 操作栏定位
    fixed: {
      default: 'right'
    },
    // 是否多选
    type: String
  },
  created() {},

  computed: {},

  methods: {
    // 多选——选择回调
    selectionChange(val) {
      this.$emit('selectionChange', val)
    },
    // 事件传出去
    goEmit(eventName, data) {
      this.$emit(eventName, data)
    },
    handlePreview(file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    }
  },
  filters: {

  }
}
</script>
<style lang='scss' scoped>
.table-wrap >>> table{
  width: 100% !important;
}
.btn{
  color: $primary;
  cursor: pointer;
  margin-left: 5px;
}
</style>


// WEBPACK FOOTER //
// src/base/table/index.vue